<template>
  <div>  
    <div class="app-user-address">
      <p>Below is the suggested standardized address, suggested updates are highlighted in orange. To continue with the standardized address please click 'Next' <br /> 
        Else, select 'Use entered address' and then click on 'Next'</p>
      <div class="app-user-entered-address">
        <section class="app-physical-address">
          <h2>
            Physical Address
          </h2>
          <div class="app-user-input-address">
            <div class="app-input-selector">
              <input type="radio" id="standardPhysicalAddress" v-model="physicalAddressType" value="standardPhysicalAddress" @change="checkSameAddress()">
              <label for="standardPhysicalAddress">Use standardized address</label>  
            </div>
            <div class="app-input-selector">
              <input type="radio" id="userEnteredPhysicalAddress" v-model="physicalAddressType" value="userEnteredPhysicalAddress" @change="checkSameAddress()"> 
              <label for="userEnteredPhysicalAddress">Use entered address</label> 
            </div>
          </div>
          <div v-if="physicalAddressType == 'userEnteredPhysicalAddress'">
            <Address :addressDetails = "userPhysicalAddress" ref="userPhysicalAddress"/>
          </div>
          <div v-else>
            <Address :addressDetails = "standardPhysicalAddress" ref="userStandardPhysicalAddress"/>
          </div>
        </section>
        <section class="app-mailing-address">
          <h2>
            Mailing Address
          </h2>
          <div class="app-user-input-address">
            <div>
              <div class="app-input-selector" v-if="!this.$store.state.guestLogin.physicalMailingAddressCheck">
                <input type="radio" id="standardMailingAddress" v-model="mailingAddressType" value="standardMailingAddress">
                <label for="standardMailingAddress">Use standardized address</label>  
              </div>
            </div>
            <div>
              <div class="app-input-selector" v-if="!$store.state.guestLogin.physicalMailingAddressCheck">
                <input type="radio" id="userEnteredMailingAddress" v-model="mailingAddressType" value="userEnteredMailingAddress" > 
                <label for="userEnteredMailingAddress">Use entered address</label> 
              </div>
            </div>
          </div>
          <div :class="{'user-same-address': this.$store.state.guestLogin.physicalMailingAddressCheck }" v-if="mailingAddressType == 'userEnteredMailingAddress'" >
            <Address :addressDetails = "userMailingAddress" ref="userMailingAddress"/> 
          </div>
          <div :class="{'user-same-address': this.$store.state.guestLogin.physicalMailingAddressCheck }" v-else>
            <Address :addressDetails = "standardMailingAddress" ref="userStandardMailingAddress"/>
          </div>
        </section>
      </div>
    </div>
    
    <BaseButtonGroup>
      <button type="button" @click="handleRouting('previous')">Previous</button>
      <button type="submit" class="app-btn-primary" @click.prevent="handleRouting('next')">
        Next
      </button>
    </BaseButtonGroup>
  </div>
</template>

<script>
import * as COMMONS from '../../store/_commons';
import { mapGetters, mapActions } from 'vuex';
import BaseButtonGroup from '@/components/ui/BaseButtonGroup';
import Address from './Address.vue';

export default {
  name: 'MelissaAddress',
  components: {
    BaseButtonGroup,
    Address
  },
  data() {
    return {
      physicalAddressType: 'standardPhysicalAddress',
      mailingAddressType: 'standardMailingAddress',
      insuranceError: false,
      userDetailAddress: [],
    }
  },
  computed: {
    ...mapGetters({
      personalInfo: COMMONS.GUEST_PERSONAL_INFO,
    }),
    userAddress() {
        return this.$store.state.guestLogin.userAddress;
    },
    standardPhysicalAddress() {
      return this.$store.state.guestLogin.standardPhysicalAddress;
    },
    standardMailingAddress() {
      return this.$store.state.guestLogin.standardMailingAddress;
    },
    userPhysicalAddress() {
      return this.$store.state.guestLogin.userPhysicalAddress;
    },
    userMailingAddress() {
      return this.$store.state.guestLogin.userMailingAddress;
    },
    checkUpdatePhysicalAddress() {
      return this.userPhysicalAddress.addressLine1 == this.standardPhysicalAddress.addressLine1 && this.userPhysicalAddress.addressLine2 == this.standardPhysicalAddress.addressLine2 &&
      this.userPhysicalAddress.city == this.standardPhysicalAddress.city && this.userPhysicalAddress.stateId == this.standardPhysicalAddress.stateId &&
      this.userPhysicalAddress.zipCode == this.standardPhysicalAddress.zipCode && this.userPhysicalAddress.zipPlus == this.standardPhysicalAddress.zipPlus
    },
    checkUpdateMailingAddress() {
      return this.userMailingAddress.addressLine1 == this.standardMailingAddress.addressLine1 && this.userMailingAddress.addressLine2 == this.standardMailingAddress.addressLine2 &&
      this.userMailingAddress.city == this.standardMailingAddress.city && this.userMailingAddress.stateId == this.standardMailingAddress.stateId &&
      this.userMailingAddress.zipCode == this.standardMailingAddress.zipCode && this.userMailingAddress.zipPlus == this.standardMailingAddress.zipPlus
    }
  },
  mounted() {
    window.scroll(0,0);
    document.body.setAttribute("tabindex", "1");
    document.body.focus();

    document.body.removeAttribute("tabindex");
    document.getElementById("app").scrollTop = 0;

    if(this.checkUpdatePhysicalAddress && this.checkUpdateMailingAddress) {
      this.$store.state.guestLogin.addressUpdateStep = 3;
      this.$store.state.guestLogin.skipStepTo = true;
    }
    else{
      this.$store.state.guestLogin.skipStepTo = false;
    }
  },
  watch: {

  },
  methods: {
    ...mapActions({
    }),
    async handleRouting(info) {
      if(info=='previous') {
        this.$store.state.guestLogin.addressUpdateStep = 1;
      }
      else {
        this.$store.state.guestLogin.physicalAddressType = this.physicalAddressType;
        this.$store.state.guestLogin.mailingAddressType = this.mailingAddressType;
        this.$store.state.guestLogin.addressUpdateStep = 3;
      }
    },
    checkSameAddress() {
      if(this.$store.state.guestLogin.physicalMailingAddressCheck) {
        this.mailingAddressType = this.physicalAddressType == 'userEnteredPhysicalAddress' ? 'userEnteredMailingAddress' :  'standardMailingAddress';
      }
    }
  }
}
</script>

<style scoped lang="scss">
.app-user-address{
  .app-user-entered-address, .app-user-standard-address {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    margin-top: 1rem;
    .app-user-input-address{
      display: flex;
      margin-top: 0.5rem;
      gap: 2rem;
      .input-radio {
        min-width: 100px;
        input[type="radio"] {
          margin: 0.5em 0;
        }
      }
      label {
        margin-top: 0.65em;
      }
    }
    h2{
      font-size: 1rem;
      font-family: "Work Sans", sans-serif;
    }
  }
  .app-user-address {
    .app-user-entered-address {
      .app-mailing-address {
        .user-mailing-address {
          margin-top: 3.5rem !important;
        }
      }
    }
  }
  .user-same-address {
    margin-top: 3.5rem;
  }
}
.app-error-message {
  color: var(--ri-red);
  @extend %font-sans-regular;
  line-height: 1.35em;
  margin: unset;
  padding: 0.5em 0;
  &.--checker {
      margin-left: 1.5em;
  }
}

@media only screen and (max-width: 510px) {
  .app-user-address{
    .app-user-entered-address{
      .app-user-input-address{
        display: block;
        margin-top: 0.5rem;
        gap: 2rem;
        .input-radio {
          min-width: 100px;
          input[type="radio"] {
            margin: 0.5em 0;
          }
        }
        label {
          margin-top: 0.65em;
        }
      }
    }

    .app-user-entered-address, .app-user-standard-address {
      display: block;
      div {
        display: block;
        width: 100%;
      }
      h2 {
        font-size: 1rem;
        font-family: "Work Sans", sans-serif;
      }
      p {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 1100px) {
  .user-same-address{
    margin-top: 0rem !important;
  }
}
</style>
